<template>
  <div id="app" style="background-color: #f5f6f7;">
      <Swiper />
      <BtnAuth />
      <BidFlow style="margin: 0 10px"/>
      <div style="height:50px;"></div>
      <TabBar />
  </div>
</template>

<script>
import Swiper from './components/Swiper';
import TabBar from './components/TabBar';
import BtnAuth  from "./components/BtnAuth";
import BidFlow from "./components/BidFlow.vue";
export default {
  name: 'App',
  components: {
    Swiper,
    TabBar,
    BtnAuth,
    BidFlow
  },
  data() {
    return {
    };
  },

};
</script>

<style>
  @media screen and (min-width: 375px) {
      #app {
        height: 130vh
      }
    }
  @media screen and (min-width: 414px) {
      #app {
        height: 120vh
      }
    }

</style>



// WEBPACK FOOTER //
// src/App.vue